import React, {Component} from 'react'
import Breakpoints from '../utils/breakpoints'
import Radium from 'radium';
import {StyleRoot, Style} from 'radium';
import _ from 'lodash';
import marked from 'marked'
import {prettifyUrl, getLang} from "../utils/util-functions";
import MapClinicsComponent from "../components/MapClinicComponent";
import Blueitems from "../components/Blueitems";
import Colors from '../utils/colors';
import ArticleImageWithText from '../components/ArticleImageWithText';
import ArticleHighlight from '../components/ArticleHighlight';
import MapComponent from '../components/MapComponent';
import {
  ShareButtons,
  ShareCounts,
  generateShareIcon
} from 'react-share';
import contentfulData from '../../contentfuldata/data.json';
import {filter, sortBy, uniqBy} from 'lodash';

export class ClinicsDetailPage extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      facebookHeight: 0,
      facebookWidth: 0
    };
    this.changeToGuide = this.changeToGuide.bind(this);
  }

  changeToGuide(headline){
    this.props.history.push("/guides/#article="+prettifyUrl(headline));
  }

  componentDidMount(){
    this.setState({
      facebookHeight: document.getElementById('rightSideContent').clientHeight,
      facebookWidth: document.getElementById('facebookContainer').clientWidth
    })
  }

  render (){

    const brand = getLang();
    const theClinic = _.find(this.props.clinics, item => prettifyUrl(item.name)===this.props.activeClinic);
    const facebookUrl = "https://www.facebook.com/plugins/page.php?href="+theClinic.facebookPage+"&tabs=timeline&width=375&height=900&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=410475685796056";
    const { FacebookShareButton } = ShareButtons;
    const items = contentfulData.servicesData[brand].services;
    const clinicServices = contentfulData.clinicsServicesData[brand].clinicsServicesData;
    const clinicServicesCategories = uniqBy(contentfulData.clinicsServicesData[brand].clinicsServicesData, 'category').map(csc => csc.category );
    const title = contentfulData.singleData[brand].singleData.frontpageItemHeader;
    const workersTitle = contentfulData.singleData[brand].singleData.clinicsWorkersTitle;
    const otherPricesTitle = contentfulData.singleData[brand].singleData.clinicsOtherPricesTitle;
    const workers = _.sortBy(filter(contentfulData.workersData[brand].workersData, (item) => {
      if (item && item.clinic && item.clinic.fields && item.clinic.fields.name)
        return item.clinic.fields.name===theClinic.name;
      return false;
    }), 'name' );
    const guides = sortBy(contentfulData.guideArticlesData[brand].guideArticlesData.filter(article => article.articleHighlight), art => art.articleImage);
    const introText = theClinic.introText || "";
    const clinicAvailableServices = theClinic.availableServices || [];
    const filteredServices = filter(clinicAvailableServices, item => {if (item.fields) return item.fields.category}).map(filteredItem => { if(filteredItem.fields) return filteredItem.fields.category});
    const otherPricesText = theClinic.otherPricesText || "";
    const reviews = theClinic.review || "";
    const clinicSeoHeadline = contentfulData.singleData[brand].singleData.clinicSeoHeadline || "";
    const clinicServicesHeadline = contentfulData.singleData[brand].singleData.clinicServicesHeadline || "";
    const noRecruitmentText = contentfulData.singleData[brand].singleData.noRecruitmentText;
    const detailText = contentfulData.singleData[brand].singleData.jobDetailText;
    const mapTitle = contentfulData.singleData[brand].singleData.frontpageMapTitle;
    marked.setOptions({
      breaks: true
    });

    return (
        <div>
            <div style={styles}>
              <div style={styles.responsiveDivider}></div>
              <div className="col-xs-12">
                <MapClinicsComponent clinic={theClinic} history={this.props.history}/>
              </div>
              <div className="clearfix"></div>
              <div style={styles.responsiveDivider}></div>
              <div className="col-xs-12 col-md-7" id="rightSideContent">
                <h3 style={{fontFamily: 'Merriweather'}}>{clinicSeoHeadline.replace("__CITY__", theClinic.name)}</h3>
                {theClinic.facebookPage &&
                  <FacebookShareButton url={theClinic.facebookPage} style={styles.shareLink}>Share</FacebookShareButton>
                }
                <p dangerouslySetInnerHTML={ {__html: marked(introText)} }></p>
                <div style={styles.responsiveDivider}></div>
                <div>
                  <h3 style={styles.h3style}>{clinicServicesHeadline.replace("__CITY__", theClinic.name)}</h3>
                  <div className="row">
                    <div className="col-xs-12">
                      {clinicServicesCategories.map((cat, catA) => {
                        return (<div key={catA}>
                          { filteredServices.indexOf(cat)>=0 &&
                            <h4 className="col-xs-12" style={styles.clinicServices} key={catA}>{cat}</h4>
                          }
                          {clinicServices.map((item, i) => {
                            if (item.category === cat && filteredServices.indexOf(cat)>=0){
                              if (clinicAvailableServices.map((as, a) => {return as.fields ? as.fields.name: ""}).indexOf(item.name)>=0) {
                                return (<div className="col-xs-12 col-sm-6" key={i} style={[styles.availableService, styles.serviceAvailable]}>{item.name}</div>)}
                              else {
                                return (<div className="col-xs-12 col-sm-6" key={i} style={[styles.availableService, styles.serviceNotAvailable]}><span style={{display:'block'}}>{item.name}</span></div>)
                              }
                            }
                          })}
                        </div>)
                      })}
                    </div>
                  </div>
                </div>
                <div className="clearfix"></div>
                <div style={{marginTop: Breakpoints.componentDivider}}></div>
                <div>
                  <h3 style={{fontFamily: 'Merriweather'}}>{title}</h3>
                  <div className="row"> <Blueitems items={items} history={this.props.history}/></div>
                </div>
                <div className="clearfix"></div>
                <div style={{marginTop: Breakpoints.componentDivider}}></div>
                <div>
                  {workers.length > 0 &&
                    <div className="col-xs-12"><h3 style={{fontFamily: 'Merriweather'}}>{workersTitle}</h3></div>
                  }
                  { workers.length > 0 &&
                      workers.map((worker, i) =>
                        <div key={i} style={styles.worker} className="col-xs-12 col-md-3 col-sm-4">
                          {(worker.image && worker.image.fields) &&
                            <img className="img-circle" style={styles.worker.image} src={worker.image.fields.file.url} />
                          }
                          { !(worker.image && worker.image.fields) &&
                            <div className="img-circle" style={{height: 150}} ></div>
                          }
                          <div style={styles.worker.name}>{worker.name}</div>
                          <div style={styles.worker.title}>{worker.title}</div>
                        </div>
                      )
                  }

                </div>
                <div className="clearfix"></div>
                <div className="row">
                <div className="col-xs-12">
                  <div>
                    { theClinic.recruitmentText &&
                    <div style={styles.recruitmentActive}>
                      <h3>{detailText}</h3>
                      <p>{theClinic.recruitmentText}</p>
                    </div>
                    }
                    { !theClinic.recruitmentText &&
                    <div style={styles.recruitmentInactive}>
                      <h3>{detailText}</h3>
                      <p>{noRecruitmentText.replace("__EMAIL__", theClinic.recruitmentEmail || "")}</p>
                    </div>
                    }
                  </div>
                  <div style={styles.responsiveDivider}></div>
                </div>
                </div>
                <div>
                  <Style scopeSelector=".otherPriceList" rules={{
                    'table': {
                      width: '100%'
                    }
                  }}/>
                  <div className="col-xs-12 otherPriceList">
                    <h3>{otherPricesTitle}</h3>
                    <p dangerouslySetInnerHTML={ {__html: marked(otherPricesText)} }></p>
                  </div>
                  <div className="row">
                  <div className="col-xs-12">
                    <div className="row" style={styles.typeContainer}>
                      {guides.map((guide, a) => {
                        if (guide.articleImage)
                          return <div style={styles.singleArticleLink} onClick={() => this.changeToGuide(guide.articleHeadline)} className="col-xs-12" key={a}><div style={styles.dividerSingleItem}><ArticleImageWithText key={a} headline={guide.articleHeadline} image={guide.articleImage.fields.file.url} /></div></div>
                        if (guide.articleHighlight)
                          return <div style={styles.singleArticleLink} onClick={() => this.changeToGuide(guide.articleHeadline)} className="col-xs-12" key={a}><div style={styles.dividerSingleItem}><ArticleHighlight key={a} headline={guide.articleHeadline} /></div></div>
                        return <div style={styles.singleArticleLink} onClick={() => this.changeToGuide(guide.articleHeadline)} className="col-xs-12" key={a}><div style={styles.dividerSingleItem}>{guide.articleHeadline}</div></div>
                        }
                      )}
                    </div>
                  </div>
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-md-4 col-md-offset-1">
                <Style scopeSelector=".clinicReview" rules={{
                  p: {
                    lineHeight: 2,
                    marginBottom: 20
                  },
                  'h2, h3, h4': {
                    marginBottom: 20
                  }
                }}/>
                {reviews &&
                  <div className="clinicReview" style={styles.review} dangerouslySetInnerHTML={ {__html: marked(reviews)} }></div>
                }
                <div id="facebookContainer" style={styles.responsiveDivider}>
                  {this.state.facebookHeight > 0 &&
                  <iframe src={facebookUrl} width={this.state.facebookWidth} height="900"
                          style={{border: 'none', overflow: 'hidden'}} scrolling="no" frameBorder="0"
                          allowTransparency="true"></iframe>
                  }
                </div>
                <div style={styles.responsiveDivider}>
                  <MapComponent items={this.props.clinics} title={mapTitle} history={this.props.history} disableMap={true}/>
                </div>
              </div>
              <div className="clearfix"></div>
              <div style={{marginTop: Breakpoints.componentDivider}}></div>
            </div>
        </div>
    )
  }

}

export default Radium(ClinicsDetailPage);

const styles = {
  width: '100%',
  margin: '0 auto',
  [Breakpoints.media.siteOverMaxWidth]: {
    width: Breakpoints.width.site
  },
  [Breakpoints.media.siteUnderPadWidth]: {

  },
  firstRow: {
    marginTop: Breakpoints.componentDivider
  },
  divider: {
    marginTop: 20
  },
  shareLink: {
    marginTop: 10,
    marginBottom: 10,
    backgroundColor: Colors.facebookColor,
    display: 'inline-block',
    paddingLeft: 15,
    paddingRight: 15,
    paddingTop: 2,
    paddingBottom: 2,
    borderRadius: 10,
    color: '#ffffff'
  },
  availableService: {
    fontWeight: 'lighter',
    color: Colors.darkBlue,
    [Breakpoints.media.siteUnderPadWidth]: {
      fontSize: 16,
      lineHeight: 1.8
    },
  },
  worker:{
    textAlign: 'center',
    height: 310,
    overflow: 'hidden',
    image: {
      width: 150,
      height: 150,
      objectFit: 'cover'
    },
    name: {
      marginTop: 10,
      fontWeight: 600,
      fontSize: 16,
      textTransform: 'uppercase'
    },
    title: {
    }
  },
  dividerSingleItem: {
    paddingTop: 10,
    paddingBottom: 10,
  },
  singleArticleLink: {
    textDecoration: 'none',
    ':hover': {
      cursor: 'pointer'
    }
  },
  serviceAvailable: {
    color: Colors.darkBlue
  },
  serviceNotAvailable: {
    color: '#dfd9d2'
  },
  responsiveDivider: {
    marginTop: Breakpoints.componentDivider,
    [Breakpoints.media.siteUnderPadWidth]: {
      marginTop: Breakpoints.mobileDivider
    }
  },
  review: {
    backgroundColor: Colors.darkBrown,
    padding: 20,
    marginTop: 10,
    borderRadius: Breakpoints.borderRadius,
    textAlign: 'center',
    'p': {
      lineHeight: 2
    }
  },
  recruitmentActive: {
    color: "#ffffff",
    backgroundColor: Colors.mainBlue,
    padding: 30,
    borderRadius: Breakpoints.borderRadius
  },
  recruitmentInactive: {
    color: "#ffffff",
    backgroundColor: Colors.mainBlue,
    padding: 30,
    borderRadius: Breakpoints.borderRadius
  },
  h3style: {
    fontFamily: 'Merriweather'
  },
  otherPriceList: {
    'table': {
      width: '100% !important'
    }
  },
  clinicServices: {
    marginTop: 30,
    fontWeight: 'regular'
  }
};


// WEBPACK FOOTER //
// ./src/components/ClinicsDetailPage.js